/*
 * 文件EN: APIAnalyze.js,
 * 文件CN: 分析报表,
 * 创建时间: Wednesday, 17th June 2020 9:56:15 am,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import * as Models from '@/api/T9/APIAnalyze'

export default {
  namespaced: true,
  actions: {
    // api查询统计
    async fetchDetails(ctx, payload) {
      return await Models.queryCount(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // api各类Api每天成功数
    async queryApiSuccState(ctx, payload) {
      return await Models.queryApiSuccState(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // 各类Api使用总览
    async queryApiUse(ctx, payload) {
      return await Models.queryApiUse(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // api调用次数预览
    async queryApiCall(ctx, payload) {
      return await Models.queryApiCall(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
  }
}
